import React from 'react';
import ThemeFontSizePicker from '../Input/Theme/ThemeFontSizePicker';
import Form from '../Form';
import { css } from '@emotion/react';
import tw from 'twin.macro';

const FontSizeButton: React.FC = () => {
  return (
    <Form.Field
      name='fontSize'
      className='fontSizeField mb-0 mx-1/8e w-4e'
      css={css`
        .ui.selection.floating.dropdown {
          width: 8.5rem !important;
          border-radius: 6px !important;
          padding-right: 0 !important;
          > .menu {
            ${tw`w-11e! mt-1/8e!`}
            .item {
              &:first-child {
                border-top: 1px solid #a0b1b3 !important;
              }
            }
          }
        }
      `}
      component={<ThemeFontSizePicker placeholder='Choose font size' floating />}
    />
  );
};

export default FontSizeButton;
